import React from "react";
import "./LoginHeader.css";
import LoginPepsiSvg from "./LoginPepsiSvg";
import { Box, Typography, styled, useMediaQuery } from "@mui/material";

const StyledHeader = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center", // centers content horizontally
  height: "var(--Primitives-Spacing-spacing-64, 64px)",
  padding: "0 var(--Primitives-Spacing-spacing-24, 24px)",
  background: "var(--Primitive-Gray-800, #363636)",
  position: "relative", // 👈 enables absolute positioning for logo
});

export default function LoginHeader() {
  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <StyledHeader>
      {/* Left-aligned logo */}
      <Box
        sx={{
          position: "absolute",
          left: "24px", // same as your horizontal padding
          display: "flex",
          alignItems: "center",
        }}
      >
        {!isMobile && <LoginPepsiSvg />}
      </Box>

      {isMobile && <LoginPepsiSvg />}
      {!isMobile && (
        <Typography
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            color: "var(--Primitives-White, #FFF)",
            fontFamily: "var(--Primitives-Typography-Font-Family-Body, Inter)",
            fontSize: "var(--Font-Size-Body, 16px)",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "var(--Line-Height-Body, 22px)",
            textAlign: "center",
          }}
        >
          Frito-Lay Agriculture
        </Typography>
      )}
    </StyledHeader>
  );
}
